import { Button } from "../ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "../ui/dialog";
import { CheckCircle, Mail } from "lucide-react";

const MarkCompleteDialog = ({ dialog, setDialog, onSendBalanceEmail, onMarkCompleteOnly }) => {
  const quote = dialog.quote;

  const isDepositPaid = quote?.deposit_paid || quote?.payment_status === "deposit_paid";
  const isPartialPaid = quote?.payment_status === "partial_paid";

  let balanceMessage;
  if (isDepositPaid) {
    balanceMessage = "This customer paid the 50% deposit. Would you like to send them a balance due email with a direct payment link for the remaining amount?";
  } else if (isPartialPaid) {
    balanceMessage = "This customer has made a partial payment. Would you like to send them a balance due email with a direct payment link for the remaining amount?";
  } else {
    balanceMessage = "This customer has not yet made a payment. Would you like to send them a balance due email with a direct payment link?";
  }

  return (
    <Dialog open={dialog.open} onOpenChange={(open) => setDialog({ ...dialog, open })}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-600" />
            Mark Service Complete
          </DialogTitle>
          <DialogDescription>
            {quote?.quote_number} — {quote?.customer_name}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          {dialog.needsBalancePayment ? (
            <div className="space-y-4">
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                <p className="text-amber-800 font-semibold mb-1">Payment Still Owed</p>
                <p className="text-amber-700 text-sm">{balanceMessage}</p>
              </div>
              <div className="flex flex-col gap-3">
                <Button
                  onClick={onSendBalanceEmail}
                  disabled={dialog.sending}
                  className="bg-[#00341d] hover:bg-[#002816] text-white w-full"
                  data-testid="send-balance-email-btn"
                >
                  {dialog.sending ? (
                    <span className="flex items-center gap-2">
                      <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                      Sending...
                    </span>
                  ) : (
                    <><Mail className="w-4 h-4 mr-2" /> Send Balance Due Email &amp; Mark Complete</>
                  )}
                </Button>
                <Button
                  variant="outline"
                  onClick={onMarkCompleteOnly}
                  disabled={dialog.sending}
                  data-testid="mark-complete-only-btn"
                >
                  Mark Complete Without Emailing
                </Button>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-zinc-600">
                Mark this service as complete? This is for fully paid quotes — no balance email will be sent.
              </p>
              <div className="flex justify-end gap-3">
                <Button
                  variant="outline"
                  onClick={() => setDialog({ open: false, quote: null, sending: false })}
                >
                  Cancel
                </Button>
                <Button
                  onClick={onMarkCompleteOnly}
                  disabled={dialog.sending}
                  className="bg-green-600 hover:bg-green-700 text-white"
                  data-testid="mark-complete-btn"
                >
                  {dialog.sending ? "Saving..." : "Mark Complete"}
                </Button>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MarkCompleteDialog;
